/**
 * Static route-to-label mapping for navigation breadcrumbs.
 */

/** Exact path matches */
export const ROUTE_LABELS: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/issuers': 'Issuers',
  '/securities': 'Securities',
  '/claims': 'Claims',
  '/claims/new': 'New Claim',
  '/evidence': 'Evidence',
  '/screens': 'Screens',
  '/screens/new': 'New Screen',
  '/characteristics': 'Characteristics',
  '/teams': 'Teams',
  '/profile': 'Profile',
  '/portfolios': 'Portfolios',
  '/portfolios/compare': 'Portfolio Comparison',
  '/proxy-proposals': 'Proposals',
  '/proxy-proposals/compare': 'Vote Comparison',
  '/proxy-proposals/def14a': 'DEF 14A Filings',
  '/reviews-dashboard': 'Reviews',
  '/reviews-dashboard/tasks': 'Review Tasks',
  '/reviews-dashboard/priorities': 'Issuer Priorities',
  '/reviews-dashboard/costs': 'Cost Dashboard',
  '/reviews-dashboard/jobs': 'Review Jobs',
  '/utilities': 'Utilities',
  '/admin/users': 'Users',
  '/admin/teams': 'Teams (Admin)',
  '/admin/role-entitlements': 'Role Entitlements',
  '/admin/plan-entitlements': 'Plan Entitlements',
};

/** Regex patterns for parameterized routes (checked in order) */
const DYNAMIC_ROUTE_LABELS: { pattern: RegExp; label: string }[] = [
  { pattern: /^\/issuers\/[^/]+$/, label: 'Issuer Detail' },
  { pattern: /^\/claims\/[^/]+$/, label: 'Claim Detail' },
  { pattern: /^\/evidence\/[^/]+$/, label: 'Evidence Detail' },
  { pattern: /^\/screens\/[^/]+\/edit\/advanced$/, label: 'Advanced Criteria' },
  { pattern: /^\/screens\/[^/]+\/edit$/, label: 'Edit Screen' },
  { pattern: /^\/screens\/[^/]+$/, label: 'Screen Detail' },
  { pattern: /^\/characteristics\/[^/]+$/, label: 'Characteristic Detail' },
  { pattern: /^\/portfolios\/[^/]+\/evaluations\/[^/]+\/compare\/[^/]+$/, label: 'Evaluation Comparison' },
  { pattern: /^\/portfolios\/[^/]+\/evaluations\/[^/]+$/, label: 'Evaluation Detail' },
  { pattern: /^\/portfolios\/[^/]+$/, label: 'Portfolio Detail' },
  { pattern: /^\/proxy-proposals\/def14a\/[^/]+$/, label: 'Proxy Statement' },
  { pattern: /^\/reviews-dashboard\/tasks\/[^/]+$/, label: 'Task Detail' },
  { pattern: /^\/reviews-dashboard\/prompts\/[^/]+$/, label: 'Prompt Detail' },
  { pattern: /^\/reviews-dashboard\/jobs\/[^/]+$/, label: 'Job Detail' },
  { pattern: /^\/admin\/teams\/[^/]+$/, label: 'Team Detail' },
];

/** Resolve a pathname to a human-readable label */
export function getDefaultRouteLabel(pathname: string): string | null {
  // Exact match first
  if (ROUTE_LABELS[pathname]) return ROUTE_LABELS[pathname];

  // Regex fallback for dynamic routes
  for (const { pattern, label } of DYNAMIC_ROUTE_LABELS) {
    if (pattern.test(pathname)) return label;
  }

  return null;
}
